module.exports = __webpack_public_path__ + "img/remainder3.af3d79f4.svg";